import { Feedback, ReferencedRecognition } from '../lib';
import { FeedbackApiData } from '../types/feedback';
import { RecognitionApiData } from '../types/recognition';

export const linkReferences = (evaluationsData: FeedbackApiData[], referencesData: RecognitionApiData[]) => {
	const references = referencesData.map((recognition) => {
		return ReferencedRecognition.fromApiData(recognition);
	});

	return evaluationsData.map((data) => {
		const evaluation = Feedback.fromApiData(data);

		const dataReference = references.find((recognition) => recognition.id === data.reference_id);

		if (data.reference_id && dataReference) {
			evaluation.reference = dataReference;
		}

		return evaluation;
	});
};
